import * as stripeJs from "@stripe/stripe-js";
import { useTranslation } from "next-i18next";
import { useCallback } from "react";

import { useSnackbar } from "@/features/common/hooks/snackbar/useSnackbar";
import { getPaymentErrorMessage } from "@/features/subscription/helper/getPaymentErrorMessage";
import { StripePaymentResponse } from "@/generated/generated-hooks";

type HandlePaymentResponseArgs = {
  response: Omit<StripePaymentResponse, "__typename">;
  successCallback: () => void;
  stripe: stripeJs.Stripe;
};

export const useHandlePaymentResponse = () => {
  const { t } = useTranslation("subscriptionPlan");
  const { openSnackbar } = useSnackbar();

  const handlePaymentResponse = useCallback(
    async ({
      response,
      stripe,
      successCallback,
    }: HandlePaymentResponseArgs) => {
      const { requiresAction, success, paymentIntentClientSecret } = response;

      if (success) return successCallback();

      if (requiresAction) {
        const { error: errorAction, paymentIntent } =
          await stripe.confirmCardPayment(paymentIntentClientSecret);

        if (!!errorAction) {
          const message = getPaymentErrorMessage(errorAction, t);

          openSnackbar({
            message,
            severity: "error",
          });
          return;
        }

        setTimeout(() => {
          successCallback();
        }, 2000); //just wait for 2s before refetching data from server since handlePaidInvoice webhook takes time

        return;
      }
    },
    [t, openSnackbar],
  );

  return handlePaymentResponse;
};
